module.exports = __webpack_public_path__ + "static/media/footer_desktop.f623d4b4.jpg";